import React, {useCallback, useState} from 'react';

import {useCopyToClipboard} from 'common/hooks/useCopyToClipboard';
import {serviceStatuses, maskString, nullCheck, npsScrore} from 'utils/div';
import {EmailIcon, Layout, Table, Text, Tooltip, WarningFilledIcon} from '@phonectas/unifon-ui-kit';
import {convertMB} from 'utils/file';
import {CustomerUser} from 'common/types/store/threeSixtyTypes';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';
// import SecretNumberIcon from 'common/components/icons/SecretNumberIcon';
// import {useTranslation} from 'react-i18next';

interface UsersTableRowProps {
	data: CustomerUser;
	onClick: (data: CustomerUser) => void;
	bnUser?: string;
}

const UsersTableRow: React.FC<UsersTableRowProps> = ({data, onClick, bnUser}) => {
	// const [t] = useTranslation();
	const [copyToClipboard] = useCopyToClipboard();
	const [isHovered, setIsHovered] = useState(false);
	const checkedPin = nullCheck(data?.pin);
	const checkedPuk = nullCheck(data?.puk);
	const {activeRow} = useThreeSixtyNewStore((state) => ({
		activeRow: state.activeRow,
	}), shallow);
	const handleCopyEmail = useCallback((e: React.MouseEvent<HTMLSpanElement>) => {
		e.stopPropagation();
		copyToClipboard(data?.email);
	}, [copyToClipboard, data?.email]);
	const handleCopyPin = useCallback((e: React.MouseEvent<HTMLTableCellElement>) => {
		e.stopPropagation();
		copyToClipboard(`PIN: ${checkedPin} / PUK: ${checkedPuk}`);
	}, [copyToClipboard, checkedPin, checkedPuk]);
	const handleRowClick = useCallback(() => {
		onClick(data);
	}, [onClick, data]);

	// for test remove this when endpint is ready
	const randomNumber = Math.floor(Math.random() * 10);
	const showThisTest = false;
	const isWarning = typeof data?.note === 'string' && data.note.trim() !== '';

	const handleMouseEnter = () => setIsHovered(true);
	const handleMouseLeave = () => setIsHovered(false);

	return (
		<Table.Row
			onClick={handleRowClick}
			selected={activeRow?.id === data?.id}
			style={{
				backgroundColor: bnUser === data.id ? 'rgba(115, 65, 47, 0.2)' : undefined,
				padding: '0px',
			}}
		>
			{/* for when hidden number is ready */}
			{/* <Table.Cell>
				<Tooltip text={t('Hidden Number')}>
					<Layout
						justifyContent="center"
						style={{width: '100%'}}
					>
						<SecretNumberIcon />
					</Layout>
				</Tooltip>
			</Table.Cell> */}
			<Table.Cell>{nullCheck(data?.name)}</Table.Cell>
			<Table.Cell>
				{
					isWarning ? (
						<Layout gap="xs" nowrap>
							<WarningFilledIcon size="xs" color="error" />
							<Text truncate={1}>{data.phone_number}</Text>
						</Layout>
					) : nullCheck(data?.phone_number)
				}
			</Table.Cell>
			<Table.Cell>
				<span
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
					}}
				>
					{data?.email && (
						<Tooltip
							text={data?.email}
						>
							<span
								style={{cursor: 'pointer'}}
								onClick={handleCopyEmail}
							>
								<EmailIcon />
							</span>
						</Tooltip>
					)}
				</span>
			</Table.Cell>
			<Table.Cell>
				{
					serviceStatuses(data?.status)
				}
			</Table.Cell>
			<Table.Cell>{nullCheck(data?.sim_type)}</Table.Cell>
			<Table.Cell>{convertMB(data?.data_used).valueInString}</Table.Cell>
			<Table.Cell>{nullCheck(data?.subscription_type)}</Table.Cell>
			<Table.Cell
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				style={{cursor: 'pointer'}}
				onClick={handleCopyPin}
			>
				{
					data?.pin && data?.puk && (
						isHovered ? `${checkedPin} / ${checkedPuk}` : `${maskString(checkedPin.toString())} / ${maskString(checkedPuk.toString())}`
					)
				}
			</Table.Cell>
			<Table.Cell>
				{
					showThisTest ? (
						<Text style={{color: npsScrore(randomNumber).color}}>
							{npsScrore(randomNumber).scoreView}
						</Text>

					) : ''
				}
			</Table.Cell>
		</Table.Row>
	);
}

export default React.memo(UsersTableRow);
